import type { CityConfig } from "../city-template/types";

export const highPointConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "High Point",
  state: "North Carolina",
  stateAbbr: "NC",
  slug: "high-point",
  route: "/cities/high-point",
  title: "Emergency Passport High Point, NC — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in High Point, NC — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Guilford & Davidson County and the Piedmont Triad area. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in High Point, NC",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help High Point and Piedmont Triad area travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=High%20Point%20North%20Carolina%20cityscape%20at%20golden%20hour%20with%20modern%20furniture%20market%20district%20skyline%2C%20historic%20downtown%20buildings%2C%20lush%20green%20trees%20in%20the%20foreground%2C%20warm%20sunset%20light%20over%20the%20Piedmont%20Triad%20region%2C%20clean%20blue%20sky%20with%20soft%20clouds%2C%20professional%20cityscape%20photography%20with%20vibrant%20warm%20colors%20and%20sharp%20architectural%20details%2C%20no%20text%20or%20signs%20on%20buildings&width=1800&height=700&seq=highpoint-hero-nc-001&orientation=landscape",
  heroImageAlt: "High Point North Carolina downtown skyline at golden hour with furniture market district and historic buildings",
  geoPosition: "35.9557;-80.0053",
  geoPlacename: "High Point, North Carolina",
  regionalAgency: {
    name: "Atlanta Passport Agency",
    address: "230 Peachtree Street NW, Suite 1400, Atlanta, GA 30303",
    distance: "Located in downtown Atlanta — approximately 330 miles from High Point via I-85",
  },
  nearbyCitiesZips: [
    { name: "High Point", zips: "27260–27265" },
    { name: "Greensboro", zips: "27401–27499" },
    { name: "Winston-Salem", zips: "27101–27199" },
    { name: "Thomasville", zips: "27360" },
    { name: "Archdale", zips: "27263" },
    { name: "Lexington", zips: "27292, 27293, 27295" },
    { name: "Jamestown", zips: "27282" },
    { name: "Trinity", zips: "27370" },
    { name: "Kernersville", zips: "27284, 27285" },
    { name: "Asheboro", zips: "27203, 27204, 27205" },
    { name: "Burlington", zips: "27215, 27216, 27217" },
    { name: "Clemmons", zips: "27012" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Piedmont Triad departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Piedmont Triad Hub", desc: "Serving High Point, Greensboro, Winston-Salem, and surrounding Triad communities" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Greensboro, NC", route: "/cities/greensboro" },
    { name: "Fast passport renewal in Winston-Salem, NC", route: "/cities/winston-salem" },
    { name: "Emergency passport help in Charlotte, NC", route: "/cities/charlotte" },
    { name: "Urgent passport services in Raleigh, NC", route: "/cities/raleigh" },
    { name: "Same-day passport help in Durham, NC", route: "/cities/durham" },
    { name: "Passport courier services in Asheville, NC", route: "/cities/asheville" },
    { name: "Expedited passport services in Asheboro, NC", route: "/cities/asheboro" },
    { name: "Emergency passport help in Kernersville, NC", route: "/cities/kernersville" },
    { name: "Emergency passport help in Thomasville, NC", route: "/cities/thomasville" },
  ],
  fpcOfficeNote: "Fast Passport Center serves High Point remotely via secure courier. We do not have a walk-in office in High Point — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Guilford & Davidson County and the Piedmont Triad area travelers.",
  fpcOfficeAddress: "525 N Tryon St., Charlotte, NC 28202",
  fpcOfficeDistance: "Serving all of Guilford & Davidson County and the Piedmont Triad region",
  serviceAreaIntro: "From downtown High Point to the furniture market district, from the Oak Hollow Lake area to the suburbs of Archdale and Jamestown — Fast Passport Center serves the entire High Point region. We regularly help travelers from Greensboro, Winston-Salem, Thomasville, and Lexington get their passports fast.",
  nearbyCitiesIntro: "We serve all High Point neighborhoods and the surrounding Piedmont Triad area including Greensboro, Winston-Salem, Thomasville, Archdale, Lexington, Jamestown, Trinity, Kernersville, Asheboro, Burlington, and Clemmons. If you are anywhere in the Piedmont Triad, we have you covered.",
  howItWorksIntro: "Most High Point travelers complete everything online and ship documents overnight. No need to drive to Atlanta or wait in line at the regional agency.",
  mistakesIntro: "High Point travelers often face long drives to the nearest regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "High Point and Piedmont Triad travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in High Point? Here are the most common ones we hear from Guilford & Davidson County travelers.",
  statePageRoute: "/states/north-carolina",
  statePageName: "North Carolina",
  dmvWebsite: "https://www.ncdot.gov",
  dmvLabel: "North Carolina DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent High Point international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Michael T.",
      location: "High Point, NC",
      rating: 5,
      text: "My passport expired 3 days before a business trip to Germany. Fast Passport Center had my renewal ready in 36 hours. Never had to leave the Triad. Outstanding service.",
      service: "Passport Renewal",
    },
    {
      name: "Patricia W.",
      location: "Jamestown, NC",
      rating: 5,
      text: "Emergency passport for a family crisis overseas. Got it in 30 hours. The team kept me updated every step. I didn't have to drive to Atlanta — incredible.",
      service: "Emergency Passport",
    },
    {
      name: "James R.",
      location: "Thomasville, NC",
      rating: 5,
      text: "First passport for my 14-year-old before our mission trip. Fast Passport Center walked us through every document and had her passport ready in 5 days. Stress-free.",
      service: "Child Passport",
    },
    {
      name: "Linda K.",
      location: "Archdale, NC",
      rating: 5,
      text: "Lost my passport 5 days before a conference in London. Fast Passport Center had a replacement in my hands in 28 hours. These guys are absolute lifesavers.",
      service: "Lost Passport",
    },
  ],
  facilities: [
    {
      id: "highpoint-1",
      name: "High Point Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1353 N Main St",
      city: "High Point",
      state: "NC",
      zip: "27262",
      phone: "(336) 882-8124",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown High Point",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary High Point facility. High volume — appointments strongly recommended. Call ahead to confirm passport acceptance.",
      icon: "ri-mail-line",
    },
    {
      id: "highpoint-2",
      name: "Greensboro Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2515 N Elm St",
      city: "Greensboro",
      state: "NC",
      zip: "27408",
      phone: "(336) 632-4042",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "12 miles northeast of High Point",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major regional facility for the Piedmont Triad. Less crowded than downtown. Photo services nearby.",
      icon: "ri-mail-line",
    },
    {
      id: "highpoint-3",
      name: "Winston-Salem Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2511 N Liberty St",
      city: "Winston-Salem",
      state: "NC",
      zip: "27105",
      phone: "(336) 631-0024",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "15 miles north of High Point",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Forsyth County and northern Triad area. Ample parking. Appointments required.",
      icon: "ri-mail-line",
    },
    {
      id: "highpoint-4",
      name: "Thomasville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "10 Salem St",
      city: "Thomasville",
      state: "NC",
      zip: "27360",
      phone: "(336) 472-2381",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "8 miles southeast of High Point",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Davidson County and southeastern Triad. Call for appointment availability.",
      icon: "ri-mail-line",
    },
    {
      id: "highpoint-5",
      name: "Guilford County Register of Deeds",
      type: "County Clerk Passport Acceptance",
      address: "201 W Market St",
      city: "Greensboro",
      state: "NC",
      zip: "27401",
      phone: "(336) 641-7556",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "Greensboro, 12 miles from High Point",
      website: "https://www.guilfordcountync.gov/",
      websiteLabel: "Guilford County Register",
      notes: "Accepts passport applications. Good alternative to post office with extended hours. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "highpoint-6",
      name: "Lexington Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "135 W 1st St",
      city: "Lexington",
      state: "NC",
      zip: "27292",
      phone: "(336) 249-8381",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "15 miles south of High Point",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Davidson County and southern Triad. Full passport services available.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 5+ hour drive to Atlanta", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "High Point photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Triad acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many High Point applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Triad families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "High Point travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in High Point." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your High Point address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in High Point before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in High Point for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 5+ hour drive to Atlanta." },
    { q: "How fast can I renew my passport in High Point?", a: "Fast Passport Center offers fast passport renewal in High Point in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to High Point?", a: "The nearest regional passport agency to High Point is the Atlanta Passport Agency, approximately 330 miles away via I-85. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from High Point without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near High Point?", a: "Same-day passport appointments are only available at the Atlanta Regional Passport Agency — approximately 5+ hours from High Point — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Guilford & Davidson County residents." },
    { q: "Do you serve the entire Piedmont Triad?", a: "Absolutely. Fast Passport Center serves the entire Piedmont Triad including High Point, Greensboro, Winston-Salem, Thomasville, Archdale, Lexington, Jamestown, Kernersville, Asheboro, and Burlington. Our courier service works seamlessly from any address in the Triad region." },
    { q: "Can I expedite a child passport in High Point?", a: "Yes. Fast Passport Center expedites child passports in High Point for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Triad families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in High Point with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Atlanta Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — High Point", address: "2630 N Main St, High Point, NC 27265", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "Walgreens — High Point", address: "1620 N Main St, High Point, NC 27262", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/" },
    { name: "Walmart Supercenter — High Point", address: "2628 S Main St, High Point, NC 27263", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/" },
    { name: "FedEx Office — Greensboro", address: "3100 Nline Ave, Greensboro, NC 27408", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM", website: "https://www.fedex.com/" },
    { name: "CVS Pharmacy — Greensboro", address: "2200 Golden Gate Dr, Greensboro, NC 27405", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "Walgreens — Winston-Salem", address: "2510 Peters Creek Pkwy, Winston-Salem, NC 27127", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/" },
    { name: "CVS Pharmacy — Thomasville", address: "1112 Randolph St, Thomasville, NC 27360", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "Walmart — Lexington", address: "160 Lowes Blvd, Lexington, NC 27292", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/" },
  ],
  dmvLocations: [
    {
      name: "NC DMV — High Point",
      address: "4620 W Market St, Greensboro, NC 27407",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver's license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "NC DMV — Greensboro",
      address: "3411 W Wendover Ave, Greensboro, NC 27407",
      hours: "Mon–Fri: 8AM–5PM",
      note: "REAL ID and passport-related ID services. Appointment strongly recommended.",
      featured: false,
    },
    {
      name: "NC DMV — Winston-Salem",
      address: "1620 Silas Creek Pkwy, Winston-Salem, NC 27103",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Forsyth County residents. REAL ID available.",
      featured: false,
    },
    {
      name: "NC DMV — Lexington",
      address: "824 S Talbert Blvd, Lexington, NC 27292",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Davidson County and southern Triad. REAL ID available.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "GSO",
      name: "Piedmont Triad International Airport",
      distance: "15 miles northeast of High Point",
      address: "1000 Ted Johnson Pkwy, Greensboro, NC 27409",
      note: "Primary airport for the Piedmont Triad region. Direct flights to major domestic destinations with seasonal international routes.",
      flightUrl: "https://www.flyfrompti.com/",
      flightLabel: "GSO Airport",
      featured: true,
    },
    {
      code: "CLT",
      name: "Charlotte Douglas International Airport",
      distance: "75 miles southwest of High Point",
      address: "5501 Josh Birmingham Pkwy, Charlotte, NC 28208",
      note: "Major international hub for long-haul international travel. American Airlines hub with direct flights to Europe, Mexico, and the Caribbean.",
      flightUrl: "https://www.cltairport.com/",
      flightLabel: "CLT Airport",
      featured: false,
    },
    {
      code: "RDU",
      name: "Raleigh-Durham International Airport",
      distance: "80 miles east of High Point",
      address: "2400 John Brantley Blvd, Morrisville, NC 27560",
      note: "Major alternative hub with additional international routes. Consider for long-haul international travel.",
      flightUrl: "https://www.rdu.com/",
      flightLabel: "RDU Airport",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      label: 'North Carolina Vital Records (NCDHHS)',
      description: 'Birth and death certificates for all NC counties. Order online, by mail, or in person at the Raleigh office.',
      url: 'https://vitalrecords.nc.gov/',
    },
    {
      label: 'Guilford County Register of Deeds',
      description: 'Marriage licenses and records for Guilford County. Apply in person or request certified copies.',
      url: 'https://www.guilfordcountync.gov/our-county/register-of-deeds',
    },
    {
      label: 'Guilford County Clerk of Superior Court',
      description: 'Divorce records and decrees for Guilford County. Contact the clerk for certified copies.',
      url: 'https://www.nccourts.gov/locations/guilford-county/guilford-county-clerk-of-superior-court',
    },
  ],
};